import { istek } from './istemci';
import type { Semalar } from './sema';

/**
 * REHBER UÇLARI (10).
 *
 * Tipler `schema.d.ts`ten TÜRETİLİR; elle yazılmaz.
 *
 * OKUMA UÇLARI YETKİ İSTEMEZ — oturum açmış herkes okur. Gerekçe kontrolcüde
 * yazılı: sistem personelin ücretini hesaplıyor, "bu tutar hangi kurala göre
 * çıktı" sorusuna cevap bulabilmek itiraz hakkının ön koşulu.
 *
 * DENETİM UÇLARI YETKİLİ ve ikisi birbirinden DAR:
 *   dogrulamaBekleyenler · dogrulanmamisParametreler
 *       → SISTEM_YONET | DONEM_KAPAT | RAPOR_GORUNTULE
 *   kilitHazirligi
 *       → SISTEM_YONET | DONEM_KAPAT          (RAPOR_GORUNTULE YOK)
 *
 * Ekran bu ikisini AYRI değişkenle denetler; tek değişken kullanılsaydı
 * `RAPOR_GORUNTULE` sahibi İK kullanıcısı iki listeyi görür ama özet
 * kutusunda 403 alırdı.
 *
 * `{PARAM:KOD}` YER TUTUCULARI PANELDE ÇÖZÜLMEZ. `fn_rehber_parametre_coz`
 * doğrudan `v_rehber` görünümünün içinde çalışıyor; `sistemDavranisi` ve
 * `ornek` alanları buraya ÇÖZÜLMÜŞ gelir. Panelde ikinci bir ikame yazılsaydı
 * parametre değerinin kaynağı ikiye bölünürdü.
 */

export type RehberMaddesi = Semalar['RehberMaddesiDto'];
export type RehberBolumu = Semalar['RehberBolumuDto'];
export type KonuDali = Semalar['KonuDaliDto'];
export type RehberAramaSonucu = Semalar['RehberAramaSonucuDto'];
export type IlgiliMadde = Semalar['IlgiliMaddeDto'];
export type RehberSurumSatiri = Semalar['RehberSurumSatiriDto'];
export type DogrulamaBekleyen = Semalar['DogrulamaBekleyenDto'];
export type DogrulanmamisParametre = Semalar['DogrulanmamisParametreDto'];
export type KilitHazirligi = Semalar['KilitHazirligiDto'];
export type RehberDisaAktarimi = Semalar['RehberDisaAktarimDto'];

/** Alt tipler madde şemasından türetilir — panelde ayrı birleşim YAZILMAZ. */
export type KararTipi = RehberMaddesi['tip'];
export type RehberKonu = RehberMaddesi['konu'];
export type RehberRol = RehberMaddesi['hedefRol'][number];
export type BelgeTuru = RehberMaddesi['belgeTuru'];

/** Dışa aktarım türü. `belgeTuru`nun `ikisi` değeri BURADA GEÇERSİZ. */
export type DisaAktarimTuru = 'prospektus' | 'kilavuz';

/** İstemci tarafı sorgu şekli — hiçbir DTO'nun karşılığı değildir. */
export interface RehberSorgusu {
  tip?: KararTipi;
  rol?: RehberRol;
  konu?: RehberKonu;
  /** `ikisi` GÖNDERİLMEZ: sunucu süzgeci zaten `ikisi` olanları elemez. */
  belgeTuru?: DisaAktarimTuru;
}

/* ------------------------------------------------------------------ */

/**
 * Rehberin tamamı, KONUYA göre gruplu.
 *
 * `RehberBolumuDto.bolum` alanı DTO örneğinde `'B. Mesai ve Puantaj'` diyor
 * ama servis `konuAdi()` basıyor (`'Mesai ve Devam'`) — örnek, konuya göre
 * gruplamaya geçilirken güncellenmemiş. Ekran alanı olduğu gibi başlık yapar.
 */
export function rehberTumu(sorgu: RehberSorgusu = {}): Promise<RehberBolumu[]> {
  return istek<RehberBolumu[]>('/v1/rehber', { sorgu: { ...sorgu } });
}

export function konuAgaci(rol?: RehberRol): Promise<KonuDali[]> {
  return istek<KonuDali[]>('/v1/rehber/konu-agaci', { sorgu: { rol } });
}

/**
 * Durum araması — "şunu yaşadım".
 *
 * `GET /rehber?arama=` DEĞİL bu uç kullanılıyor: yalnız bu uç hangi günlük
 * dil ifadesinin eşleştiğini (`eslesme`) döndürüyor ve ucun tek varlık sebebi
 * bu. Diğeri seçilseydi iki uç aynı işi yapar, `eslesme` ölürdü.
 */
export function rehberAra(metin: string, rol?: RehberRol): Promise<RehberAramaSonucu[]> {
  return istek<RehberAramaSonucu[]>('/v1/rehber/ara', { sorgu: { metin, rol } });
}

export function rehberMaddesi(kod: string): Promise<RehberMaddesi> {
  return istek<RehberMaddesi>(`/v1/rehber/madde/${encodeURIComponent(kod)}`);
}

export function ilgiliMaddeler(kod: string): Promise<IlgiliMadde[]> {
  return istek<IlgiliMadde[]>(`/v1/rehber/madde/${encodeURIComponent(kod)}/ilgili`);
}

export function surumGecmisi(kod: string): Promise<RehberSurumSatiri[]> {
  return istek<RehberSurumSatiri[]>(`/v1/rehber/madde/${encodeURIComponent(kod)}/surum-gecmisi`);
}

/* --- Denetim uçları (yetkili) -------------------------------------- */

export function dogrulamaBekleyenler(): Promise<DogrulamaBekleyen[]> {
  return istek<DogrulamaBekleyen[]>('/v1/rehber/dogrulama-bekleyenler');
}

export function dogrulanmamisParametreler(): Promise<DogrulanmamisParametre[]> {
  return istek<DogrulanmamisParametre[]>('/v1/rehber/dogrulanmamis-parametreler');
}

export function kilitHazirligi(): Promise<KilitHazirligi> {
  return istek<KilitHazirligi>('/v1/rehber/kilit-hazirligi');
}

/* --- Dışa aktarım --------------------------------------------------- */

export function rehberDisaAktar(
  tur: DisaAktarimTuru,
  rol?: RehberRol,
): Promise<RehberDisaAktarimi> {
  return istek<RehberDisaAktarimi>(`/v1/rehber/disa-aktar/${tur}`, { sorgu: { rol } });
}
